import React from 'react';
import { Box } from '@mui/material';
import CommentList from '../../common/comment/CommentList';
const SalesActivityTemplate = () => {
  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <CommentList />
    </Box>
  );
};

export default SalesActivityTemplate;
